<template>
  <el-dialog :title="$t('636')" :close-on-click-modal="false" append-to-body :visible.sync="visible">
    <el-card class="box-card">
      <el-row slot="header">
        {{ $t('630') }}
      </el-row>
      <el-row>{{ info.name }}</el-row>
    </el-card>
    <el-card class="box-card">
      <el-row slot="header">
        {{ $t('631') }}
      </el-row>
      <el-row class="see-ids">{{ info.staff_names }}</el-row>
    </el-card>
    <el-card class="box-card">
      <el-row slot="header">
        {{ $t('632') }}
      </el-row>
      <el-row class="see-content" v-html="info.content"></el-row>
    </el-card>
    <el-card class="box-card">
      <el-row slot="header">
        {{ $t('223') }}
      </el-row>
      <el-row>
        <el-radio-group v-model="info.is_top">
          <el-radio v-for="(item, index) in topConfig" :key="index" disabled :label="item.label">
            {{ item.name }}
          </el-radio>
        </el-radio-group>
      </el-row>
    </el-card>
  </el-dialog>
</template>

<script>
import { topConfig } from './config'
import { detailFn } from 'api/tool/message'

export default {
  data() {
    return {
      visible: false,
      info: {},
      topConfig: topConfig(this)
    }
  },
  methods: {
    async init(item) {
      this.visible = true
      this.getMsgInfo(item)
    },
    async getMsgInfo(item) {
      const res = await detailFn({ id: item.id })
      if (res && res.code === 1) this.info = res.data
    }
  }
}
</script>
<style lang="less">
.box-card {
  margin-bottom: 20px;
  box-shadow: inherit !important;
  .el-card__header {
    padding: 9px 15px;
  }
  .el-card__body {
    padding: 15px;
  }
  .el-row {
    margin-bottom: 0;
  }
  .see-content {
    height: auto;
    max-height: 600px;
    overflow: auto;
  }
  .see-ids {
    height: auto;
    max-height: 150px;
    overflow: auto;
  }
}
</style>
